import { Component, inject, model } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-something-went-wrong",
  standalone: true,
  imports: [TranslatePipe, RouterLink],
  templateUrl: "./something-went-wrong.component.html",
  styleUrl: "./something-went-wrong.component.scss",
})
export class SomethingWentWrongComponent {
  readonly #activatedRoute = inject(ActivatedRoute);
  readonly backUrl = model<string>();
  readonly backLabel = model<string>("GAST-PORTAL-NG.SOMETHING_WENT_WRONG.BACK_LINK");

  constructor() {
    this.#activatedRoute.data.pipe(takeUntilDestroyed()).subscribe((data) => {
      if (data["backUrl"] !== undefined && data["backUrl"] !== null) {
        this.backUrl.set(data["backUrl"]);
      }
      if (data["backLabel"] !== undefined && data["backLabel"] !== null) {
        this.backLabel.set(data["backLabel"]);
      }
    });
  }
}
